import React, { Component } from 'react';
import '../App.css';
import {getURL} from './SocialMediaFunctions.js';

class SocialBox extends Component {


  setStatus(status, source) {
    var output = (status[0] === 'AVAILABLE') ? 'AVAILABLE?' : status;
    // If Instagram fails, make status "INCONCLUSIVE"
    if(source === "Instagram" && status[0] === "error"){
      output = "INCONCLUSIVE"
    }
    return output;
  }

  render() {
    var query   = this.props.searchQuery;
    var source  = this.props.source;
    var content = this.props.content;
    var image = this.props.image;

    if (Object.keys(content).length !== 0) {
      var divContent = getURL(query, source, content);
      return (
        <div className='somebox' style={{"border" : "1px solid " + divContent.borderColor }}>
          <div className="somebox__title" style={{"color" : divContent.textColor}}>
            {this.setStatus(content, source)}
          </div>
          <img src={image} className="somebox__logo" alt={source}/>
          <div className="somebox__link" style={{"backgroundColor" : divContent.color}}>
            {divContent.html}
          </div>
        </div>
      );
    } else {
      return (
        <div className='somebox'>
          <div className="somebox__title">
            ...
          </div>
          <img src={image} className="somebox__logo" alt={source}/>
          <div className="somebox__link" style={{"backgroundColor" : "grey"}}>
            Loading...
          </div>
        </div>
      );
    }
  }
}

export default SocialBox;



// WEBPACK FOOTER //
// ./client/src/Engines/SocialBox.js